import { render, staticRenderFns } from "./FriendDetail.vue?vue&type=template&id=e0e6e336&"
import script from "./FriendDetail.vue?vue&type=script&lang=js&"
export * from "./FriendDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports